<template>
	<div class="info-form">
		<div class="title"><i></i>红包领取信息填写</div>
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="info-ruleForm">
			<div class="code-title">
				<span><i class="icon"></i>扫描二维码</span>
				<!-- <el-button @click="wxScan" class="code-btn" type="warning" size="small"
					v-loading.fullscreen.lock="!wxReady"><i class="iconfont">&#xe65c;</i>扫描
				</el-button> -->
			</div>
			<div class="code">
				<div class="tips">扫描说明：请从左到右依次扫描两个二维码。</div>
				<div class="result">
					<div class="result-item" :class="{success:ruleForm.labelStr}">
						<div class="img">
							<img class="code-img" src="../assets/img/code01.jpg" />
							<img class="success-icon" v-if="ruleForm.labelStr" src="../assets/img/success-icon.png" />
						</div>
						<span v-if="!ruleForm.labelStr">左边二维码实例图</span>
						<span v-if="ruleForm.labelStr">扫描成功</span>
						<el-button @click="wxScan" class="code-btn" type="warning" size="small"><i
								class="iconfont">&#xe65c;</i>扫描左边二维码</el-button>
					</div>
					<div class="result-item" :class="{success:ruleForm.jfStr}">
						<div class="img">
							<img class="code-img" src="../assets/img/code02.jpg" />
							<img class="success-icon" v-if="ruleForm.jfStr" src="../assets/img/success-icon.png" />
						</div>
						<span v-if="!ruleForm.jfStr">右边二维码实例图</span>
						<span v-if="ruleForm.jfStr">扫描成功</span>
						<el-button @click="wxScan" class="code-btn" type="warning" size="small"><i
								class="iconfont">&#xe65c;</i>扫描右边二维码</el-button>
					</div>
				</div>
			</div>
			<div class="code-title">
				<span><i class="icon"></i>上传照片</span>
			</div>
			<div class="photograph-wrapper">
				<div class="photograph">
					<div class="photograph-img-item" v-if="ruleForm.qrImg.localId">
						<el-image class="item-img" :src="WKWebview ? ruleForm.qrImg.localData : ruleForm.qrImg.localId" fit="contain"
							:preview-src-list="WKWebview ?
						ruleForm.qrImg.localData : ruleForm.qrImg.localId" @click.stop="handleClickItem">
						</el-image>
						<el-button class="delete" @click="delImg(0)" type="primary" icon="el-icon-delete"></el-button>
					</div>
					<div v-if="!ruleForm.qrImg.localId" class="photograph-add">
						<div class="photograph-add-img">
							<img src="../assets/img/examples-img01.jpg" />
							<span class="tips">二维码示例照片</span>
						</div>
						<el-button @click="uploadFile(0)" class="photograph-add-btn" type="warning" size="small"><i
								class="iconfont">&#xe671;</i>上传二维码照片</el-button>
					</div>
				</div>
				<div class="photograph">
					<div class="photograph-img-item" v-if="ruleForm.drumImg.localId">
						<el-image class="item-img" :src="WKWebview ? ruleForm.drumImg.localData : ruleForm.drumImg.localId" fit="contain"
							:preview-src-list="WKWebview ?
						ruleForm.drumImg.localData : ruleForm.drumImg.localId" @click.stop="handleClickItem">
						</el-image>
						<el-button class="delete" @click="delImg(1)" type="primary" icon="el-icon-delete"></el-button>
					</div>
					<div v-if="!ruleForm.drumImg.localId" class="photograph-add">
						<div class="photograph-add-img">
							<img src="../assets/img/examples-img02.jpg" />
							<span class="tips">油桶示例照片</span>
						</div>
						<el-button @click="uploadFile(1)" class="photograph-add-btn" type="warning" size="small"><i
								class="iconfont">&#xe671;</i>上传油桶照片</el-button>
					</div>
				</div>
			</div>
			<el-form-item>
				<el-button class="main-btn" type="primary" @click="submitForm" v-loading.fullscreen.lock="!wxReady">
					立即领取
				</el-button>
			</el-form-item>
		</el-form>
		<el-dialog :visible.sync="dialogVisible">
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				WKWebview: '',
				wxReady: false,
				url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
				srcList: [
					'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
					'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
				],
				location: false,
				fullscreenLoading: false,
				hideUpload: false,
				oilHideUpload: false,
				limitCount: 2,
				dialogImageUrl: '',
				dialogVisible: false,
				ruleForm: {
					labelStr: '',
					jfStr: '',
                    qrImg: {
                        localId: '',
                        serverId: '',
                        localData: ''
                    },
                    drumImg: {
                        localId: '',
                        serverId: '',
                        localData: ''
                    }
				},
				scanResult: ''
			};
		},
		methods: {
			handleClickItem() {
				this.$nextTick(() => {
					let domImage = document.querySelector(".el-image-viewer__canvas");
					if (!domImage) {
						return;
					}
					domImage.addEventListener("click", () => {
						document.querySelector(".el-image-viewer__close").click();
					});
				})
			},
			uploadFile(idx) {
				let app = this
				this.$wx.chooseImage({
					count: 1,
					sizeType: ['compressed'],
					sourceType: ['album', 'camera'],
					success(res) {
						app.syncUpload(res.localIds, idx)
					}
				})
			},
			syncUpload(localIds, idx) {
				let app = this;
				var localId = localIds.pop();
				this.$wx.uploadImage({
					localId: localId, // 需要上传的图片的本地ID，由chooseImage接口获得
					isShowProgressTips: 1, // 默认为1，显示进度提示
					success: function(res) {
						app.getLocalImg({
							serverId: res.serverId,
							localId: localId,
						}, idx)
					}
				});
			},
			getLocalImg(img, idx) {
				let app = this
				this.$wx.getLocalImgData({
					localId: img.localId, // 图片的localID
					success: function(res) {
						var localData = res.localData; // localData是图片的base64数据，可以用 img 标签显示
						img.localData = localData
                        if(idx == 0){
                            app.ruleForm.qrImg.localId = img.localId
                            app.ruleForm.qrImg.localData = img.localData
                            app.ruleForm.qrImg.serverId = img.serverId
                        }else{
                            app.ruleForm.drumImg.localId = img.localId
                            app.ruleForm.drumImg.localData = img.localData
                            app.ruleForm.drumImg.serverId = img.serverId
                        }
                        app.$forceUpdate()
					}
				});
			},
			delImg(idx) {
                if (idx == 0) {
                    this.ruleForm.qrImg.localId = ''
                    this.ruleForm.qrImg.localData = ''
                    this.ruleForm.qrImg.serverId = ''
                } else {
                    this.ruleForm.drumImg.localId = ''
                    this.ruleForm.drumImg.localData = ''
                    this.ruleForm.drumImg.serverId = ''
                }
            },
			sign() {
				let url = window.location.href.split('#')[0]
				this.$http.fetchPost("/api/wx/sign", {
					url
				}).then((res) => {
					let data = res.data
					this.$wx.config({
						debug: false,
						appId: data.appid,
						timestamp: data.timestamp,
						nonceStr: data.noncestr,
						signature: data.signature,
						jsApiList: ['updateAppMessageShareData',
							'updateTimelineShareData', 'getLocation', 'scanQRCode',
							'chooseImage', 'uploadImage'
						]
					});
				});
			},
			wxScan() {
				let app = this
				this.$wx.scanQRCode({
					needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
					scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
					success: function(res) {
						let str = res.resultStr
						if (str.indexOf('weixin.qq.com') >= 0) {
							app.checkLabel(str)
							return
						}
						if (str.indexOf('qdbphb.fawjiefang.com.cn') >= 0) {
							app.checkJfCode(str)
							return
						}
						app.$message.error('请扫描正确的二维码')
					},
					fail: function(err) {
						app.$message.error(err.errMsg)
					}
				});
			},
			checkLabel(str) {
				let app = this
				this.$http.fetchGet("/api/label/checkLabel", {
					labelUrl: str
				}).then(res => {
					if (res.data.code == 0) {
						app.ruleForm.labelStr = str
					} else {
						app.ruleForm.labelStr = ''
						app.$message.error('此二维码已失效')
					}
				})
			},
			checkJfCode(str) {
				let app = this
				this.$http.fetchGet("/api/label/checkJfCode", {
					jfUrl: str
				}).then(res => {
					if (res.data.code == 0) {
						app.ruleForm.jfStr = str
					} else {
						app.ruleForm.jfStr = ''
						app.$message.error('此二维码已失效')
					}
				})
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			submitForm() {
				if (!this.ruleForm.labelStr || !this.ruleForm.jfStr || !this.ruleForm.qrImg.serverId
                || !this.ruleForm.drumImg.serverId) {
					this.$message.error('请将信息填写完整')
					return
				}
				this.$http.fetchPost('/api/label/saveLabel', {
						labelUrl: this.ruleForm.labelStr,
						jfUrl: this.ruleForm.jfStr,
						qrServeId: this.ruleForm.qrImg.serverId,
						drumServeId: this.ruleForm.drumImg.serverId,
					}).then(res => {
						if (res.data.code == 0) {
							let label = res.data.label
							let userInfo = localStorage.getItem("userInfo")
							this.getBonus(userInfo == null ? '' : userInfo, label)
						} else {
							this.$message.error('领取失败，请确认上传的信息是否正确')
						}
					})
					.fail(err => {
						this.$message.error(err)
					})
			},
			getLocation() {
				let app = this
				this.$wx.getLocation({
					type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
					success: function(res) {
						var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
						var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
						let loginRecord = {};
						loginRecord.lat = latitude;
						loginRecord.lng = longitude;
						app.$http.fetchPost("/api/loginrecord/save", loginRecord).then((r) => {
							if (r.data.code == 0) {
								app.location = true
							}
						});
					},
					complete: function(r) {
						if (r.errMsg === "getLocation:cancel") {
							alert("获取位置授权后才可以领取红包")
							app.getLocation()
						}
					}
				});
			},
			getBonus(userInfo, label) {
				this.$http.fetchPost("/api/bonus/getBonus", {
					userInfo: userInfo,
					label: label
				}).then((res) => {
					if (res.data.code == 0) {
						this.$message.success(res.data.msg)
					} else {
						this.$message.error(JSON.stringify(res.data.msg))
					}
				})
			},
			getUrlKey(name) { //获取url 参数
				var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
				var r = window.location.search.substr(1).match(reg);
				if (r != null) return unescape(r[2]);
				return null;
			},
		},
		created() {
			let app = this
			app.sign()
			this.$wx.ready(function() {
				app.wxReady = true
				app.getLocation()
				app.WKWebview = window.__wxjs_is_wkwebview
			})
		}
	}
</script>

<style lang="scss">

</style>
